import { ReactNode } from 'react';
import { CheckboxVariant, FunnelImage } from 'core/flow/entities';
import { CheckboxImage } from './CheckboxImage';
import { CheckboxOption } from './CheckboxOption';
import { CheckboxPill } from './CheckboxPill';
import { CheckboxTile } from './CheckboxTile';

type AnswerCheckboxProps = {
  checked: boolean;
  value: string;
  image?: FunnelImage;
  onAnswerClick: (value: string, checked: boolean) => void;
  children?: ReactNode;
  variant?: CheckboxVariant;
};

export const AnswerCheckbox = ({
  children,
  checked,
  onAnswerClick,
  value,
  image,
  variant = CheckboxVariant.OPTION,
  ...otherProps
}: AnswerCheckboxProps) => {
  const getCheckbox = (type: CheckboxVariant) => {
    if (type === CheckboxVariant.TILE) {
      return (
        <CheckboxTile
          image={image}
          value={value}
          checked={checked}
          onAnswerClick={onAnswerClick}
          {...otherProps}
        >
          {children}
        </CheckboxTile>
      );
    }

    if (type === CheckboxVariant.PILL) {
      return (
        <CheckboxPill
          image={image}
          value={value}
          checked={checked}
          onAnswerClick={onAnswerClick}
          {...otherProps}
        >
          {children}
        </CheckboxPill>
      );
    }

    if (type === CheckboxVariant.IMAGE) {
      return (
        <CheckboxImage
          imageSrc={image?.src}
          value={value}
          checked={checked}
          onAnswerClick={onAnswerClick}
          {...otherProps}
        >
          {children}
        </CheckboxImage>
      );
    }

    return (
      <CheckboxOption
        image={image}
        value={value}
        checked={checked}
        onAnswerClick={onAnswerClick}
        {...otherProps}
      >
        {children}
      </CheckboxOption>
    );
  };

  return <>{getCheckbox(variant)}</>;
};
